import { call, put, takeEvery } from 'redux-saga/effects';
import { adminConfigService } from '../../services';
import {
  getAdminConfig,
  saveAdminConfig,
  changeLoading,
} from '../../features/adminConfigSlice';

function* getAdminConfigSaga(action) {
  try {
    yield put(changeLoading(true));
    const response = yield call(
      adminConfigService.getAdminConfig,
      // action.payload
    );
    yield put(saveAdminConfig(response.data));
  } catch (error) {
    console.log(error);
    yield put(changeLoading(false));
  }
}

export default function* publicData() {
  yield takeEvery(getAdminConfig, getAdminConfigSaga);
}
